import store from '@/store'

export const blobToBuffer = (blob, callback) => {
  let fr = new FileReader()
  fr.readAsArrayBuffer(blob)
  fr.addEventListener(
    'loadend',
    (e) => {
      let buf = e.target.result
      callback(buf)
    },
    false
  )
}

export const blobToDataURL = (blob, callback) => {
  let a = new FileReader()
  a.onload = function (e) {
    callback(e.target.result)
  }
  a.readAsDataURL(blob)
}

export const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export const blobSplit = (blobs, cb, size = 1280) => {
  var reader = new FileReader()
  reader.onload = function (e) {
    //读取完毕后输出结果
    var dataURL = e.target.result
    const base64 = dataURL.slice(dataURL.indexOf(',') + 1)
    //
    let bstr = atob(base64),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    let blob = new Blob([u8arr], { type: 'audio/pcm' })
    //
    let blobSize = blob.size
    const arr = []
    if (blobSize > size) {
      // 计算需要分几份
      let sliceCount = Math.ceil(blobSize / size)
      for (let i = 0; i < sliceCount; ++i) {
        // 计算分片起始位置
        let start = i * size
        // 计算分片结束位置
        let end = start + size
        // 最后一片特殊处理
        if (end > blobSize) {
          end = blobSize
        }
        arr.push(blob.slice(start, end))
      }
    }
    cb(arr)
  }
  reader.readAsDataURL(blobs)
}

export const quietAudio = () => {
  const uintLength = 300
  const u8arr = new Uint8Array(uintLength)
  return u8arr

  // const base64 =
  //   'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA='
  // let bstr = atob(base64),
  //   n = bstr.length,
  //   u8arr = new Uint8Array(n)
  // while (n--) {
  //   u8arr[n] = bstr.charCodeAt(n)
  // }
  // return new Blob([u8arr], { type: 'audio/pcm' })
}

export const digitalHeartBeat = (() => {
  let quietAudioData = quietAudio()
  let worker = null
  let blobList = []
  let isFirst = true
  let isFinshed = false
  return function (ws) {
    worker = new Worker('/worker.js')
    // 启动worker
    worker.postMessage('start')
    // 接收worker消息
    worker.onmessage = (e) => {
      if (e.data == 'send') {
        if (blobList.length > 0) {
          isFirst = false
          const blob = blobList.shift()
          console.log('worker.onmessage', blobList.length)

          ws && blob && ws?.send(blob)
        }
        // else if (!isFirst && !isFinshed) {
        //   console.log('sleep quietAudio !')
        //   ws && ws?.send(quietAudioData)
        // }
      }
    }
    worker.onerror = (e) => {
      console.error('worker错误', e)
    }
    return {
      close() {
        isFirst = true
        // 关闭worker
        worker.postMessage('close')
        worker.terminate()
        worker = null
        blobList = []
      },
      break() {
        blobList = []
      },
      getBlobList() {
        return blobList.length
      },
      inputBlod(blob) {
        isFirst = false
        blobList.push(...blob)
      },
      setStatus(stat) {
        isFinshed = stat
      }
    }
  }
})()
